'use client';

export const config = {
    defaultData: {
        id: '', // 活动id
        backgroundColor: '#F3F4F7',
        titleColor: '#000',
        subTitleColor: '#000',
        themeColor: '#000',
        showListBtn: 'N',
        listBtnColor: '#000',
        showRewardsBtn: 'N',
        rewardsBtnColor: '#000',
        bgImage: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1729765995047/lucky-border.png',
        btnImage: '	https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1729766008302/lucky-btn.png',
        prizeFontColor: '#000',
        prizeBgColor1: '#ffd995',
        prizeBgColor2: '#ffbf4a',
        prizeBgColor3: '',
        loginType: 'page',
    },
};

export type DicType = {
    label?: string | number;
    value: string | undefined;
};

export const OtherOpthions: DicType[] = [
    {
        value: '_others',
        label: '自定义',
    },
];

export const GrayOpthions: DicType[] = [
    {
        value: '#F3F4F7',
        label: '灰色',
    },
    ...OtherOpthions,
];

export const BlackOpthions: DicType[] = [
    {
        value: '#000',
        label: '黑色',
    },
    ...OtherOpthions,
];
